<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>
            Update Staff Attendance <b>[{{ moment(date).format('MMM YYYY') }}]</b>
            <small class="ml-2"><span class="text-warning">LT</span> = Late, <span class="text-primary">L</span> = Leave, <span class="text-info">HD</span> = Half Day</small>
            <small v-if="serverdata && serverdata.is_lfs" class="ml-2 text-muted">
              | <b>Cum. Leaves:</b> Leave/Sick/Absent = 1.0, Half Day = 0.5, 3 Late = 1.0
            </small>
          </h5>
        </div>
        <div class="col-md-4 mb-2 text-right">
          <a-date-picker
            v-model="selectedDate"
            @change="handleDateChange"
            :disabledDate="disabledDate"
            :format="dateFormat"
            size="large"
            style="width: 70%"
          />
        </div>
      </div>
    </div>
    <div >
      <update-attendance
        :serverdata="serverdata"
        :selected-date="moment(selectedDate).format('YYYY-MM-DD')"
        @attendance-submitted-successfully="handleAttendanceSubmitted"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import updateAttendance from '@/components/StaffAttendance/Forms/UpdateAttendance'

export default {
  name: 'bulkUpdatePage',
  components: { updateAttendance },
  data: function() {
    return {
      date: null,
      selectedDate: moment(),
      serverdata: {
        headers: [],
        monthlength: 0,
        attendancedata: [],
      },
      // staffattendance: [],
      activedata: [],
      dateFormat: 'YYYY-MM-DD',
    }
  },
  created: function() {
    this.date = this.$route.params.month || moment().startOf('month')
    this.loadAttendance()
  },
  methods: {
    moment,
    handleDateChange(value) {
      this.date = value
      this.selectedDate = value
      this.loadAttendance()
    },
    // handleUpdatedAttendance(updatedAttendance) {
    //   this.staffattendance = updatedAttendance
    //   this.updateActiveData(this.staffattendance)
    // },
    handleAttendanceSubmitted() {
      this.loadAttendance()
    },

    updateActiveData(attendanceData) {
      this.activedata = []
      if (!attendanceData || !attendanceData.attendancedata) return
      attendanceData.attendancedata.forEach(staff => {
        staff.data.forEach(day => {
          if (!['AB', '-'].includes(day.status)) {
            this.activedata.push(day.value)
          }
        })
      })
    },
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    loadAttendance() {
      this.$http.get(`/api/staff/attendance/report/monthly?start_date=${moment(this.date).startOf('month').format('YYYY-MM-DD')}&end_date=${moment(this.date).endOf('month').format('YYYY-MM-DD')}`)
        .then((data) => {
          const response = data.data.data
          const attendancedata = response.staffAttendance.map((d, rc) => {
            return {
              id: d.id,
              staffcode: d.staff_code,
              staffid: d.system_staff_id,
              staffname: d.first_name + ' ' + d.last_name,
              cumulative_leaves: d.cumulative_leaves || null,
              overall: d.overall || null,
              data: response.headers.map(de => {
                const row = response.staffAttendance[rc].attendances.find(({ date }) => date === de.date) ||
                            { date: de.date, status: '-' }
                return {
                  ...row,
                  value: d.id + ':' + de.dayNo,
                  day: de.day,
                  isholiday: de.is_holiday,
                  status: (de.day === 'Sun') ? 'S' : (de.is_holiday) ? 'H' : row.status,
                  cellstyle: this.getCellStyle(row.status, de),
                }
              }),
            }
          })

          const monthlength = attendancedata.length > 0 ? attendancedata[0].data.length : 0
          this.serverdata = {
            headers: response.headers,
            monthlength,
            attendancedata,
            is_lfs: response.is_lfs || false,
          }

          // this.staffattendance = {
          //   headers: response.headers,
          //   monthlength,
          //   attendancedata,
          // }

          this.updateActiveData(this.staffattendance)
        })
        .catch(console.error)
    },
    getCellStyle(status, dayInfo) {
      if (status === 'P' || status === 'HP') return 'green'
      if (dayInfo.day === 'Sun') return 'darkred'
      if (dayInfo.is_holiday || status === 'AB') return 'red'
      if (['LT', 'LO', 'LE', 'OT', 'EL', 'L'].includes(status)) return 'green'
      return ''
    },
  },
}
</script>
